import { supabase } from '../../../services/supabase';
import { RawSprint, Sprint } from '../types';

export async function fetchTeamSprintsInRange(
  teamId: string | null,
  startDate: string,
  endDate: string,
): Promise<Sprint[]> {
  if (!teamId) {
    return [];
  }

  const { data, error } = await supabase
    .from('sprints')
    .select('*')
    .eq('team_id', teamId)
    .or(
      `and(start_date.lte.'${endDate}',end_date.gte.'${startDate}'),` + // Sprints that overlap with the range
        `and(start_date.gte.'${startDate}',start_date.lte.'${endDate}'),` + // Sprints that start within the range
        `and(end_date.gte.'${startDate}',end_date.lte.'${endDate}')`, // Sprints that end within the range
    )
    .order('start_date', { ascending: false });

  if (error) {
    throw new Error(`Failed to fetch sprints: ${error.message}`);
  }

  return (data || []).map((sprint: RawSprint) => ({
    id: sprint.id,
    name: sprint.name,
    startDate: sprint.start_date,
    endDate: sprint.end_date,
    status: sprint.status,
  }));
}
